// Brand Colors
export const colors = {
  brand: {
    pennBlue: "#091744",
    majorelleBlue: "#4545F2",
    jordyBlue: "#9EB9E6",
    magnolia: "#EBEBF5",
    whiteSmoke: "#F4F4F4",
    tiffanyBlue: "#ACE5DA",
    faluRed: "#801818",
    goldenrod: "#EDDA74",
    sahara: "#CC8E00",
    lightGreyGreen: "#B7E1A1",
    treeGreen: "#2A7E19",
  },
  // Interface functional colors
  greys: {
    black: "#000000",
    darkGray: "#313131",
    mediumGray: "#575757",
    lightGray: "#989797",
    white: "#FFFFFF",
  },
};
